module.exports = __webpack_public_path__ + "img/zip.d86be7f9.png";